module.exports = __webpack_public_path__ + "static/media/content.8444d544.png";


//////////////////
// WEBPACK FOOTER
// ./src/staticPage/aboutUs/img/content.png
// module id = 271
// module chunks = 0